<script lang="ts">
	import { Checkbox } from '@repo/ui'

	interface Props {
		label: string
		name?: string | null
		checked?: boolean
		children?: import('svelte').Snippet
	}

	let { label, name = null, checked = $bindable(false), children }: Props = $props()
</script>

<Checkbox {name} small smallText bind:checked>
	{label}
</Checkbox>

<div class="mt-5"></div>

<div hidden={!checked}>
	{@render children?.()}
</div>
